import * as React from "react";
import { Stack, TextField, Typography } from "@mui/material";

interface Props {
  label: string;
  currentValue?: number;
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  required?: boolean;
}

export const DimensionInput: React.FC<Props> = ({
  label,
  currentValue,
  value,
  onChange,
  placeholder,
  required = false,
}) => {
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Typography sx={{ width: '80px' }}>{label}:</Typography>
      {currentValue !== undefined && (
        <Typography sx={{ width: '100px' }}>
          {currentValue.toFixed(2)} ft
        </Typography>
      )}
      <TextField
        size="small"
        placeholder={placeholder || (currentValue !== undefined ? `Current: ${currentValue.toFixed(2)}` : placeholder)}
        type="number"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={value !== "" && (isNaN(parseFloat(value)) || parseFloat(value) <= 0)}
        helperText={value !== "" && (isNaN(parseFloat(value)) || parseFloat(value) <= 0) ? "Must be > 0" : ""}
        sx={{ flex: 1 }}
        inputProps={{ min: 0, step: 0.01 }}
        required={required}
      />
    </Stack>
  );
};